
export default function getNumberFromText(str){
    let num = str.match(/[\d\.]+/g)
    num = num.filter(n=> n!==".")
    return num[0]
}